import React from "react";
import { Card } from "../card";

import { GridWrapper } from "../GridWrapper/GridWrapper";
import { AddClass } from "./AddClass";
import { ClassList } from "./ClassList";

export const ClassesComponent = () => {
  return (
    <GridWrapper
      totalColumns={3}
      childrens={[
        {
          component: (
            <Card wrapperStyle={{ height: "100%" }} cardTitle="Add class">
              <div>
                <AddClass />
              </div>
            </Card>
          ),
          gridSpan: 1,
        },
        {
          component: (
            <Card
              wrapperStyle={{
                height: "100%",
              }}
              cardTitle="All classes"
            >
              <div>
                <ClassList />
              </div>
            </Card>
          ),
          gridSpan: 2,
        },
      ]}
    />
  );
};
